import { render, staticRenderFns } from "./TableDutiesListVigilance.vue?vue&type=template&id=27bc9ea3"
import script from "./TableDutiesListVigilance.vue?vue&type=script&lang=js"
export * from "./TableDutiesListVigilance.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports